import { addListener } from "@grindex-common/helpers/domManipulation";
import { events } from "@grindex-common/helpers/events";
import { videoRenderer } from "@grindex-common/helpers/videoRenderer";
import { ImageOverviewDom } from "./imageOverview.dom";
import { XylemImage } from "@grindex-common/helpers/XylemImage.class";
import TabNames from "@grindex-client/components/Tabs/TabNames.class";
import asyncModule from "@grindex-client/components/Module/asyncModule";

(function listenForEvent() {
	asyncModule("imageOverview", events.tabLoadedEvent(new TabNames().product.overview), init);
})();

function init($view) {
	const $module = $view;
	const dom = new ImageOverviewDom($module);

	initializeCarousel();

	function initializeCarousel() {
		const $slider = setupSlider();

		if (!$slider) {
			return;
		}

		dom.selectFirstSlide();

		bindEvents();

		function bindEvents() {
			addListener(dom.getOverlayElements(), "click", selectContent);
			addListener(dom.getImageElements(), "click", selectContent);
			addListener(window, "load", setupSlider.bind(this));
			addListener(window, events.OVERVIEW_ACCORDION_OPENED, () => {
				if (dom.carouselIsVisible() && typeof $slider.redrawSlider !== "undefined") {
					$slider.redrawSlider();
				}
			});
		}

		function setupSlider() {
			if (dom.carouselShouldBeSlider()) {
				return $(dom.getCarouselElement()).bxSlider({
					useCSS: false,
					auto: false,
					infiniteLoop: false,
					hideControlOnEnd: true,
					controls: true,
					pager: true,
				});
			}

			return null;
		}

		function selectContent(e) {
			const $parent = e.currentTarget.parentElement;

			if (dom.elementIsSelected($parent)) {
				return false;
			}

			dom.selectListItem($parent);

			const $clickedElement = dom.getClickedImageElement(e);

			if (isVideo($clickedElement)) {
				const existingVideo = dom.getExistingVideo($clickedElement);

				if (existingVideo) {
					existingVideo.remove();
				}

				videoRenderer.renderOverlayVideo($clickedElement.dataset.key, $clickedElement.dataset.videoPlayerId, dom.getFeaturedImageElement());
			} else {
				renderImg($clickedElement, $parent);
			}

			return true;
		}

		function isVideo($element) {
			return $element.dataset.key ? true : false;
		}

		function renderImg($image) {
			const imageOptions = {
				src: $image.src,
				alt: $image.alt,
				data: {
					caption: $image.dataset.caption,
				},
			};

			const image = new XylemImage(imageOptions);

			dom.setFeaturedImage(image);
		}
	}
}

export default {
	view: "imageOverview",
	init,
};
